// normalizeCodesForUi.ts

export type HcpcsApiItem = {
  code: string;
  confidence: number;
  evidence?: string;
  long_description?: string;
  short_description?: string;
  liked?: boolean | null;
  case_note?: string;
};

export type ICDType = {
  id: number;
  icd_code: string;
  icd_description: string;
  liked: boolean | null;
  icd_rationale: string;
  icd_voice_note_quotes: string[];
  icd_confidence: string;
  additionalFeedback: string | null;
};

export type CPTType = {
  id: number;
  cpt_code: string;
  cpt_description: string;
  cpt_confidence: string;
  cpt_rationale: string;
  liked: boolean | null;
  cpt_voice_note_quotes: string[];
  associated_icds: ICDType[];
  additionalFeedback: string | null;
};

const toPercentString = (n: number) => `${Math.round(n)}%`;

export const normalizeCodesForUi = (data: any[], type?: string): CPTType[] => {
  if (!Array.isArray(data)) return [];

  if (type === "HCPCS") {
    return (data as HcpcsApiItem[]).map((x, idx) => ({
      id: idx + 1,
      cpt_code: x.code,
      cpt_description: x.long_description ?? x.short_description ?? "",
      cpt_confidence: toPercentString(x.confidence ?? 0),
      cpt_rationale: x.evidence ?? "",
      liked: x.liked ?? null,
      cpt_voice_note_quotes: x.case_note ? [x.case_note] : [],
      associated_icds: [],
      additionalFeedback: null,
    }));
  }

  return data as CPTType[];
};
